import { render, staticRenderFns } from "./patient-merge-dialog.vue?vue&type=template&id=2afab219&scoped=true&lang=pug&"
import script from "./patient-merge-dialog.vue?vue&type=script&lang=ts&"
export * from "./patient-merge-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afab219",
  null
  
)

export default component.exports